import React, { ChangeEvent, useEffect, useState } from "react";
import Button from "../../common/button";
import { useAppDispatch, useAppSelector } from "../../../hooks/store-hooks";
import {
  useLazyGetUserByIdDataQuery,
  useUserActionMutation,
  useUserUpdateMutation,
} from "../../../store/api/userApi";
import { useParams } from "react-router-dom";
import EditProfile from "./edit-profile";
import {
  // BellCrossed,
  // ChatCircledText,
  EditPencil,
  Instagram,
  Linkedin,
  Lock,
  Siren,
  // Share,
  // Siren,
  Twitter,
} from "../../../icons";
import ChatContainer from "../../chat";
import { getUser } from "../../../store/actions/chatActions";
import ProfileBadgeAvatar from "./profile-avatar";
import { MODAL_NAME } from "../../../constants";
import { openModal } from "../../../store/slices/modalSlice";
import { VerifiedBadgeIcon } from "../../../icons/badge-icons";

const Profile = () => {
  const dispatch = useAppDispatch();
  const { userData } = useAppSelector((state: any) => state.user);
  const { isOpcMember } = useAppSelector((state: any) => state.home);
  const { chatClient } = useAppSelector((state: any) => state.chat);
  const [triggerUserUpdate] = useUserUpdateMutation();
  const [userProfile, setUserProfile] = useState<string>(
    userData?.profile_picture || "",
  );
  const [userBanner, setUserBanner] = useState<string>(userData?.banner || "");

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isMoreOpen, setisMoreOpen] = useState(false);
  const [chatData, setchatData] = useState<any>();
  const [messageLoading, setmessageLoading] = useState(false);
  const [isAllowHideOnBackClick, setIsAllowHideOnBackClick] = useState(true);

  const openEditModal = () => {
    setIsEditModalOpen(true);
  };

  const closeModal = () => {
    setIsEditModalOpen(false);
  };

  const { user_id: userId } = useParams();
  const [refetch] = useLazyGetUserByIdDataQuery();
  const [triggerUserAction] = useUserActionMutation();

  useEffect(() => {
    setUserProfile(userData?.profile_picture || "");
    setUserBanner(userData?.banner);
  }, [userData]);

  useEffect(() => {
    const payload = {} as any;
    if (userProfile !== userData?.profile_picture && userProfile !== "") {
      payload.profile_picture = userProfile;
    }
    if (userBanner !== userData?.banner && userBanner !== "") {
      payload.banner = userBanner;
    }
    if (Object.keys(payload).length > 0) {
      triggerUserUpdate(payload);
    }
  }, [userProfile, userBanner]);

  useEffect(() => {
    document.addEventListener("mousedown", handleHidewhenClickedOutside);
    return () => {
      document.removeEventListener("mousedown", handleHidewhenClickedOutside);
    };
  }, [isAllowHideOnBackClick]);

  const handleHidewhenClickedOutside = (e: any) => {
    const popOverElement = ["more-options", "more-button"];

    if (!isAllowHideOnBackClick) {
      return;
    }
    if (!popOverElement.includes(e.target.id)) setisMoreOpen(false);
  };

  const handleFileChange = (
    event: ChangeEvent<HTMLInputElement>,
    type: "profile" | "banner",
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          if (type === "banner") setUserBanner(reader.result as string);
          else setUserProfile(reader.result as string);
          event.target.value = "";
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const action = async ({ type }: { type: string }) => {
    await triggerUserAction({ user_id: userId, action: type });
    refetch({ userId });
  };

  return (
    <div className="rounded-lg overflow-visible bg-white w-full">
      <div className="pb-14 relative">
        {userBanner ? (
          <img
            src={userBanner}
            alt="banner"
            className="inset-0 w-full h-40 object-cover"
          />
        ) : (
          <div className="w-full h-40 bg-[#007AFF]"></div>
        )}
        {userData?.is_self && (
          <>
            <input
              type="file"
              accept=".jpg, .jpeg, .png"
              id="upload-banner"
              className="hidden"
              onChange={(e) => handleFileChange(e, "banner")}
            />
            <label
              htmlFor="upload-banner"
              className="absolute right-4 top-4 bg-white rounded-full p-2 cursor-pointer"
            >
              <EditPencil fillColor="#007AFF" width={16} height={16} />
            </label>{" "}
          </>
        )}
        <div className="relative">
          {userData?.badge ? (
            <ProfileBadgeAvatar
              profileImage={userProfile}
              customDivClassName=" h-40 w-40 absolute -top-28 md:left-6 md:translate-x-0 left-[50%] transform translate-x-[-50%] border-[8px] p-2"
              customImgClassName="h-40 w-40 absolute -top-28 md:left-6 md:translate-x-0 left-[50%] transform translate-x-[-50%] p-2 "
              customIconDivClassName="absolute z-[11] top-7 md:left-[11.5%] left-[47%] "
              customStyle1="w-[190px] h-8  absolute -bottom-2 z-[11] overflow-hidden"
              customStyle2="w-[290px] h-16 absolute top-12 z-10 -left-10 overflow-hidden"
              customStyle3="w-36 h-36"
              customStarWidth={32}
              customStarHeight={32}
              badge={userData.badge}
            />
          ) : (
            <img
              src={userProfile}
              alt="profile_picture"
              className={`rounded-full h-40 w-40 absolute -top-28 md:left-6 md:translate-x-0 left-[50%] transform translate-x-[-50%] bg-[#00000066] object-cover ${userData?.memberships?.is_opc ? "profile-picture" : ""}`}
            />
          )}
        </div>
        {userData?.is_self && (
          <>
            <input
              type="file"
              accept=".jpg, .jpeg, .png"
              id="upload-profile"
              className="hidden"
              onChange={(e) => handleFileChange(e, "profile")}
            />
            <label
              htmlFor="upload-profile"
              className="absolute right-4 bg-white rounded-full p-2 cursor-pointer"
            >
              <EditPencil fillColor="#090909" width={16} height={16} />
            </label>
          </>
        )}
      </div>
      <div className="px-8">
        <div className="flex md:justify-between flex-wrap justify-center md:flex-row flex-col items-center">
          <div className="flex flex-col md:justify-start justify-center items-center md:items-start">
            <h1 className="text-3xl font-semibold flex items-center">
              {userData?.first_name} {userData?.last_name}
              {userData?.is_verified && (
                <div className="ml-2">
                  <VerifiedBadgeIcon width={24} height={24} />
                </div>
              )}
            </h1>
            <p className="text-lg text-slate-500 w-fit">
              {userData?.designation}
            </p>
          </div>
          <div className="flex gap-2 font-semibold">
            <div className="flex items-center text-sm">
              <div className="flex items-center space-x-1 bg-primary-600 p-1 px-2 rounded-full border border-solid border-primary-200 bg-[#F5F5F5]">
                <img
                  src="/assets/logo/OneGoldCoin.png"
                  alt=""
                  className="w-4 h-4"
                />
                <span className="ml-1 text-gray-700">
                  {userData?.account_balances?.coins || 0}
                </span>
              </div>
            </div>
            <div className="flex items-center text-sm">
              <div className="flex items-center space-x-1 bg-primary-600 p-1 px-2 rounded-full border border-solid border-primary-200 bg-[#F5F5F5]">
                <img
                  src="/assets/icons/star-red.png"
                  alt=""
                  className="w-4 h-4"
                />
                <span className="ml-1 text-gray-700">
                  {userData?.account_balances?.xp || 0}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="pt-2 text-sm md:block hidden">
          {userData?.description}
        </div>
        <div className="flex gap-6 md:justify-start justify-center my-2">
          <div className="flex flex-col items-start">
            <span className="text-primary-500 text-[13px] font-normal">
              Post
            </span>
            <p className="text-primary-900 font-semibold">
              {userData?.network?.posts}
            </p>
          </div>
          <div className="px-4 flex flex-col  items-start border-x-[1px] border-gray-200">
            <span className="text-primary-500 text-[13px] font-normal">
              Followers
            </span>
            <p className="text-primary-900 font-semibold">
              {userData?.network?.followers}
            </p>
          </div>
          <div className="flex flex-col items-start">
            <span className="text-primary-500 text-[13px] font-normal">
              Following
            </span>
            <p className="text-primary-900 font-semibold">
              {userData?.network?.following}
            </p>
          </div>
        </div>
        <div className="flex md:flex-row flex-col flex-wrap md:justify-between justify-evenly py-4 items-center gap-8">
          <div>
            {!userData?.is_self ? (
              <div className="flex gap-2">
                {userData?.network?.is_followed ? (
                  <Button
                    customClasses="w-40 py-1 font-bold rounded-xl text-md"
                    variant="secondary"
                    onClick={() => action({ type: "unfollow" })}
                  >
                    Following
                  </Button>
                ) : (
                  <Button
                    customClasses="w-40 py-1 font-bold rounded-xl text-md"
                    onClick={() => action({ type: "follow" })}
                  >
                    Follow
                  </Button>
                )}
                <Button
                  customClasses="w-40 py-1 font-bold rounded-xl text-md"
                  variant={isOpcMember ? "secondary" : "disabled"}
                  isSubmitting={messageLoading}
                  disabled={!isOpcMember}
                  onClick={() => {
                    setmessageLoading(true);
                    dispatch(getUser({ chatClient, userId }))
                      .unwrap()
                      .then((result) => {
                        setchatData(() => ({
                          user: result,
                        }));
                      });
                  }}
                >
                  {isOpcMember ? (
                    "Message"
                  ) : (
                    <div
                      className="flex justify-center gap-1 items-center"
                      // onClick={() => {
                      //   trackEvent(MixpanelEvent.BUTTON_PRESSED, {
                      //     button_name: "profile_others_message_press",
                      //   });
                      // }}
                    >
                      <Lock height={18} width={18} strokeColor="#000" />
                      <p className="text-base text-primary-900">Message</p>
                    </div>
                  )}
                </Button>
                <div className="relative flex flex-col">
                  <Button
                    id="more-button"
                    customClasses="w-24 py-1 font-bold rounded-xl text-md md:block hidden "
                    variant="secondary"
                    onClick={() => {
                      setisMoreOpen((prevState) => !prevState);
                    }}
                  >
                    More
                  </Button>
                  {isMoreOpen && (
                    <div
                      onMouseEnter={() => {
                        setIsAllowHideOnBackClick(false);
                      }}
                      onMouseLeave={() => {
                        setIsAllowHideOnBackClick(true);
                      }}
                      className="absolute z-20 top-11 right-0 h-20 w-[260px] bg-primary-300 backdrop-blur-[20px] p-4 rounded-lg"
                    >
                      <div
                        className="flex w-full justify-start py-3 gap-3 items-center cursor-pointer"
                        onClick={() =>
                          dispatch(
                            openModal({
                              modalName: MODAL_NAME.REPORT_USER,
                              modalData: userId,
                            }),
                          )
                        }
                      >
                        <Siren />
                        <p className="font-normal text-base leading-snug">
                          Report User
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <>
                <Button
                  customClasses="w-40 py-1 font-bold rounded-xl text-md text-black bg-gray-200"
                  onClick={openEditModal}
                >
                  Edit Profile
                </Button>
                <EditProfile isOpen={isEditModalOpen} onClose={closeModal} />
              </>
            )}
          </div>
          <div className="flex gap-4">
            {userData?.socials?.linkedin && (
              <a href={userData?.socials?.linkedin} target="_blank">
                <Linkedin width={32} height={32} />
              </a>
            )}
            {userData?.socials?.instagram && (
              <a href={userData?.socials?.instagram} target="_blank">
                <Instagram width={32} height={32} />
              </a>
            )}
            {userData?.socials?.x && (
              <a href={userData?.socials?.x} target="_blank">
                <Twitter width={32} height={32} />
              </a>
            )}
          </div>
        </div>
      </div>
      {!userData?.is_self ? (
        <ChatContainer
          isRightPanelHide={true}
          otherUserData={chatData}
          setMessageLoading={setmessageLoading}
        />
      ) : null}
    </div>
  );
};

export default Profile;
